import { useCreateRxEligibilityConversation } from "@/api/generated";
import { TextSendMessageRequestType as SendMessageRequestType } from "@/api/model";
import { usePostNoriMessage } from "@/api/mutations/conversation";
import { AD_CONVERSION_EVENTS } from "@/config/adConversionEvents";
import { useAnalytics, useEventContext } from "@/hooks/analytics";
import { usePartnerIntent } from "@/hooks/usePartnerIntent";
import { usePropagatedRouter } from "@/hooks/usePropagatedRouter";
import { useRxQuestionnaireStore } from "@/store";

export default function useGlp1EligibilityPress() {
  const router = usePropagatedRouter();
  const { mutate: createEligibilityConversation, isPending } =
    useCreateRxEligibilityConversation();
  const { mutate: postNoriMessage } = usePostNoriMessage();
  const { open: openRxQuestionnaire } = useRxQuestionnaireStore();
  const { track } = useAnalytics();
  const eventContext = useEventContext();
  const { getLocalPartnerIntent } = usePartnerIntent();

  const onPress = () => {
    getLocalPartnerIntent().then((partnerIntent) => {
      createEligibilityConversation(
        {
          data: {
            initial_message: "See if I qualify for GLP-1s",
            partner_intent: partnerIntent ?? null,
          },
        },
        {
          onSuccess: ({ conversation_id }) => {
            track(AD_CONVERSION_EVENTS.conversationCreated, {
              event_context: {
                ...eventContext,
                conversation_id,
                conversation_type: "nori",
              },
            });
            router.navigate(`/conversation/${conversation_id}`);
            postNoriMessage({
              message: "Yes",
              conversationId: conversation_id,
              type: SendMessageRequestType.rx_input,
            });
            setTimeout(() => {
              openRxQuestionnaire(conversation_id);
            }, 300);
          },
        },
      );
    });
  };

  return { onPress, isPending };
}
